











































































import Vue from "vue";
import _ from "lodash";
import config from "@/config";

export default Vue.extend({
    name: "PlanCard",
    props: {
        planItem: {
            type: Object,
            required: true
        },
        orgConfig: {
            type: Object
        }
    },
    data() {
        return {
            rowWidth: ["80%", "90%", "90%", "80%"],
            titleWidth: "60%"
        };
    },
    computed: {
        loading(): boolean {
            return _.isEmpty(this.planItem);
        },
        trainingOccupationEnabled(): boolean {
            if (_.keys(this.orgConfig).length == 0) {
                return true;
            }
            return !!this.orgConfig["trainingOccupationEnabled"];
        }
    }
});
